/**
 * FC Button Dropdown
 * Handles open/close toggle and selection sync for the custom popup dropdown
 * used by variant-button options with more than 3 values.
 *
 * Developer: Jon
 * Updated: 2026-06-08
 */
(function () {
  'use strict';

  function init() {
    var dropdowns = document.querySelectorAll('[data-fc-button-dropdown]');
    dropdowns.forEach(function (dropdown) {
      setupDropdown(dropdown);
    });
  }

  function setupDropdown(dropdown) {
    var trigger = dropdown.querySelector('[data-fc-button-dropdown-trigger]');
    var list = dropdown.querySelector('[data-fc-button-dropdown-list]');
    if (!trigger || !list) return;

    var selectedSpan = trigger.querySelector('.fc-button-dropdown__selected');

    /* Toggle list on trigger click */
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      toggle(trigger, list, !isOpen);
    });

    /* Handle option selection via label click / radio change */
    list.addEventListener('change', function (e) {
      var radio = e.target;
      if (radio.type !== 'radio') return;

      /* Update the trigger text */
      if (selectedSpan) {
        selectedSpan.textContent = radio.value;
      }

      /* Close the dropdown */
      toggle(trigger, list, false);
    });

    /* Close on outside click */
    document.addEventListener('click', function (e) {
      if (!dropdown.contains(e.target)) {
        toggle(trigger, list, false);
      }
    });

    /* Keyboard: Escape to close */
    dropdown.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        toggle(trigger, list, false);
        trigger.focus();
      }
    });
  }

  function toggle(trigger, list, open) {
    trigger.setAttribute('aria-expanded', String(open));
    list.hidden = !open;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
